import axios from "axios";
import { attachResponseInterceptor } from "./response-interceptor";
import { attachRequestInterceptor } from "./request-interceptor";
import { config } from "../../config/runtime-config";
// Get API base URL from runtime/build config with fallback
const getApiBaseUrl = () => {
    const envUrl = config.apiBaseUrl;
    const fallbackUrl = "https://localhost:7247/api/";
    if (!envUrl) {
        console.warn("REACT_APP_API_BASE_URL not found in configuration, using fallback:", fallbackUrl);
        return fallbackUrl;
    }
    return envUrl;
};
const baseURL = getApiBaseUrl();
export const siteX = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});
// Attach middleware interceptors
attachRequestInterceptor(siteX);
attachResponseInterceptor(siteX);
